import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class accountingReportByAccount_template extends vnTemplate{

    protected validationsList: validationsList_template;
    protected filterPaymentsDate: filterDropdown_template;
    protected accountsFilter: multipleSelector_template
    protected companyFilter: multipleSelector_template

    protected getTemplateHtml(): string{

        return `

           <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div><label for="idPayment" class="form-label form-label-box">Payment Date</label>` + this.filterPaymentsDate.getHtmlBuild() + `</div>
                        ${this.accountsFilter.getHtmlBuild()}
                        ${this.companyFilter.getHtmlBuild()}

                    </div>
                    
                    <div class="w-right">
                        <button class="btn icon i-export" type="button" data-bind="visible: brandCosts().length > 0, event: { click: onClickExport }">Export</button>
                        <button class="btn icon i-export" type="button" data-bind="visible: brandCosts().length > 0, event: { click: onClickExportCommerce }">Export with Commerce Split</button>
                        <button class="btn icon i-export" type="button" data-bind="visible: brandCosts().length > 0, event: { click: onClickExportBalanceTransfer }">Export Balance Transfer </button>

                    </div>
                
                </div>
                <div class="w-justify">
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                           <div id="selected-accounts"></div>
                           <div id="selected-companies"></div>
                        </div>
                    </div>
                </div>
            </div>
            
            ` + this.validationsList.getHtmlBuild() + ` 
            
            <div class="w-double-list" data-bind="visible: brandCosts().length > 0">
            
                <div class="double-list-header">
                       <h3 class="double-list-title">Accounting Report</h3>
                </div>
                
                <div class="w-double-list-body">
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total CAD Costs:</strong>
                            <span data-bind="text:totalCostCAD()"></span>
                        </div>
                       
                   </div>
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total USD Costs:</strong>
                            <span data-bind="text: totalCostUSD()"></span>
                        </div>
                   </div>
                   
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total GBP Costs:</strong>
                            <span data-bind="text: totalCostGBP()"></span>
                        </div>
                   </div>
                   
                   <div class="double-list-body">
                        <div class="double-list-sub-title">
                            <strong>Grand Total EUR Costs:</strong>
                            <span data-bind="text: totalCostEUR()"></span>
                        </div>
                   </div>
                 </div>
                 
            </div>
            
            <div data-bind="foreach: brandCosts">
            
            <h3 class="section-title prop full" data-bind="text: $data.brand, css: $data.brandIcon"></h3>
            
            <div data-bind="foreach: $data.totalCosts, visible: $data.totalCosts.length > 0">
           <div class="w-double-list">
                <div class="double-list-header">
                       <span class="align-left"><h3 class="double-list-title small" data-bind="text: account, css: $parent.brandIcon"></h3></span>
                </div>
                
                <div class="w-double-list-body">
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total CAD Costs:</strong>
                            <span data-bind="text:totalCostsCAD"></span>
                       </div> 
                       <dl class="double-list">
                           <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostCAD"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostCAD"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostCAD"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostCAD"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostCAD"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostCAD"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostCAD"></span></dd>
                           <dt><span>Adjustments:</span></dt>
                           <dd><span data-bind="text: adjustmentsCostCAD"></span></dd>
                       </dl>
                    </div>
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total USD Costs:</strong>
                            <span data-bind="text:totalCostsUSD"></span>
                       </div>
                       <dl class="double-list">
                            <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostUSD"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostUSD"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostUSD"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostUSD"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostUSD"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostUSD"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostUSD"></span></dd>
                           <dt><span>Adjustments:</span></dt>
                           <dd><span data-bind="text: adjustmentsCostUSD"></span></dd>
                       </dl>
                    </div>
                    
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total GBP Costs:</strong>
                            <span data-bind="text:totalCostsGBP"></span>
                       </div>
                       <dl class="double-list">
                            <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostGBP"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostGBP"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostGBP"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostGBP"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostGBP"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostGBP"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostGBP"></span></dd>
                           <dt><span>Adjustments:</span></dt>
                           <dd><span data-bind="text: adjustmentsCostGBP"></span></dd>
                       </dl>
                    </div>
                
                    <div class="double-list-body">
                       <div class="double-list-sub-title">
                            <strong>Total EUR Costs:</strong>
                            <span data-bind="text:totalCostsEUR"></span>
                       </div>
                       <dl class="double-list">
                            <dt><span>Commission:</span></dt>
                           <dd><span data-bind="text: commissionCostEUR"></span></dd>
                           <dt><span>Performance:</span></dt>
                           <dd><span data-bind="text: performanceCostEUR"></span></dd>
                           <dt><span>Consulting Base:</span></dt>
                           <dd><span data-bind="text: consultingBaseCostEUR"></span></dd>
                           <dt><span>Bonuses:</span></dt>
                           <dd><span data-bind="text: bonusCostEUR"></span></dd>
                           <dt><span>Tips:</span></dt>
                           <dd><span data-bind="text: tipsCostEUR"></span></dd>
                           <dt><span>Hosting:</span></dt>
                           <dd><span data-bind="text: hostingCostEUR"></span></dd>
                           <dt><span>Training:</span></dt>
                           <dd><span data-bind="text: trainingCostEUR"></span></dd>
                           <dt><span>Adjustments:</span></dt>
                           <dd><span data-bind="text: adjustmentsCostEUR"></span></dd>
                       </dl>
                    </div>
                </div>
               </div>
             </div>
            
            `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.filterPaymentsDate = new filterDropdown_template("filterPaymentsDate", this.getTemplateViewModel(), this.caller);
        this.filterPaymentsDate.setLabel("Payment")
        this.accountsFilter = new multipleSelector_template('accountsFilter', this.getTemplateViewModel(), this.caller);
        this.accountsFilter.setLabel("Accounts");
        this.accountsFilter.setFilterContainerClass('margin-neg');
        this.accountsFilter.setTagContainerId('selected-accounts');
        this.accountsFilter.setTagContainerCaption('Selected Accounts:');

        this.companyFilter = new multipleSelector_template('companyFilter', this.getTemplateViewModel(), this.caller);
        this.companyFilter.setLabel("Company");
        this.companyFilter.setFilterContainerClass('margin-neg');
        this.companyFilter.setTagContainerId('selected-companies');
        this.companyFilter.setTagContainerCaption('Selected Companies:');
    }

    protected getTemplateName(): string{
        return "accountingReportByAccount-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
            payments: ko.observableArray([])
            ,accounts: ko.observableArray([])
            ,idPayment: ko.observable('')
            ,brand: ko.observable(null)
            ,brandCosts: ko.observableArray([])
            ,brandsCommerceData: ko.observableArray([])
            ,totalCostCAD: ko.observable('')
            ,totalCostUSD: ko.observable('')
            ,totalCostGBP: ko.observable('')
            ,totalCostEUR: ko.observable('')
            ,balanceTransfersCurrentPeriod: ko.observableArray([])
            ,balanceTransfersNextPeriod: ko.observableArray([])
            ,userTaxes: ko.observableArray([])
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
            ,onClickExport: function (data, event) { huit_neuf_this.onClickExport(data); }
            ,onClickExportCommerce: function (data, event) { huit_neuf_this.onClickExportCommerce(data); }
            ,onClickExportBalanceTransfer: function (data, event) { huit_neuf_this.onClickExportBalanceTransfer(data); }
        };
    }

    public getViewModelForRequest() {

        return {
            filters: {
                idPayment: this.getTemplateViewModel().filterPaymentsDate.selectedOption,
                idAccounts: this.getTemplateViewModel().accountsFilter.selectedItems,
                idCompanies: this.getTemplateViewModel().companyFilter.selectedItems,
            }
        }
    }

    public onChangeFilterAction(data) {

        this.caller.filterSimpleOnChange();
    }

    public onClickExport(data){
        this.caller.exportToCSV(data.brandCosts(),data.totalCostCAD(),data.totalCostUSD(),data.totalCostGBP(),data.totalCostEUR(),data.balanceTransfersCurrentPeriod(),data.balanceTransfersNextPeriod());
    }

    public onClickExportCommerce(data){
        this.caller.exportCommerceToCSV(data.brandsCommerceData(),data.totalCostCAD(),data.totalCostUSD(),data.totalCostGBP(),data.totalCostEUR(),data.balanceTransfersCurrentPeriod(),data.balanceTransfersNextPeriod());
    }

    public setPayments(payments){

        this.getTemplateViewModel().payments(payments);
    }

    public setAccounts(accounts){

        this.accountsFilter.setItems(accounts);
        this.accountsFilter.setSelectedItems(accounts.filter(acc => {return acc.id < 4 || acc.id == 5}))
    }

    public setCompanies(companies){

        this.companyFilter.setItems(companies);
        this.companyFilter.setSelectedItems(companies)
    }

    public setIdPayment(idPayment){
        this.getTemplateViewModel().idPayment(idPayment);
    }

    public setBrandCosts(brandCosts){
        this.getTemplateViewModel().brandCosts(brandCosts);
    }

    public setBrandsCommerceData(brandsCommerceData){
        this.getTemplateViewModel().brandsCommerceData(brandsCommerceData);
    }

    public setTotalCostCAD(totalCostCAD){
        this.getTemplateViewModel().totalCostCAD(totalCostCAD);
    }

    public setTotalCostGBP(totalCostGBP){
        this.getTemplateViewModel().totalCostGBP(totalCostGBP);
    }

    public setTotalCostEUR(totalCostEUR){
        this.getTemplateViewModel().totalCostEUR(totalCostEUR);
    }

    public setBalanceTransfersCurrentPeriod(balanceTransfersCurrentPeriod){
        this.getTemplateViewModel().balanceTransfersCurrentPeriod(balanceTransfersCurrentPeriod);
    }

    public setBalanceTransfersNextPeriod(balanceTransfersNextPeriod){
        this.getTemplateViewModel().balanceTransfersNextPeriod(balanceTransfersNextPeriod);
    }

    public setTotalCostUSD(totalCostUSD){
        this.getTemplateViewModel().totalCostUSD(totalCostUSD);
    }

    public setUserTaxes(userTaxes){
        this.getTemplateViewModel().userTaxes(userTaxes);
    }

    public setBrand(brand){
        this.getTemplateViewModel().brand(brand);
    }

    public setPaymentDateOptions(options) {

        let paymentDates = [];
        for (let item of options)
        {
            paymentDates.push(item)
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterPaymentsDate.setOptions(paymentDates);
        this.onChangeFilterAction = temp;
    }

    public onClickExportBalanceTransfer(data){
        this.caller.exportBalanceTransferToCSV();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/accountingReportByAccount_template.ts